/* global $, jQuery, google, Flickity, PhotoSwipe, gsap, TweenLite, Expo, THEME_OBJ, PhotoSwipeUI_Default: false */
/* global preloader: false */
// /* global slick: false */
// /* global isotope: false */

( function() {
	'use strict';

} )();


(function($) {
	'use strict';

	/**
	 * Google Map Function
	 */
	$.fn.googleMap = function (options) {
		const directionsService = new google.maps.DirectionsService();
		const directionsRenderer = new google.maps.DirectionsRenderer({
			polylineOptions: {
				strokeColor: "#983228",
				strokeOpacity: .8
			}
		});

		let el = $(this);
		let theResponse = '';

		let settings = $.extend({
			'lat': '37.979561',
			'lng': '23.728487',
			'zoom': 13,
			'styles': '',
			'places_categories': false,
			'locations': [{
				lat: -33.890542,
				lng: 151.274856,
				address: '',
				tooltip: false,
				marker_svg: false,
				marker_svg_file: false,
				image_src: '',
				image_alt: '',
				info_title: '',
				info_text: '',
				info_btn: '',
				info_btn_url: '',
				info_btn_target: '',
			}],
		}, options);

		let markers = [];
		let bounds = new google.maps.LatLngBounds();

		let offsetHeight = $('nav.navbar').height() * 2;

		let map = new google.maps.Map(el[0], {
			zoom: settings.zoom,
			zoomControl: true,
			scaleControl: false,
			scrollwheel: false,
			styles: settings.styles ? settings.styles : '',
			streetViewControl: false,
			disableDoubleClickZoom: true,
			mapTypeControl: false,
			fullscreenControl: false
		});

		$.each(settings.locations, function (i, attr) {
			let locLatLng = new google.maps.LatLng(attr.lat, attr.lng);
			let infoButtonString = '';
			let infoImageUrl = '';
			let markerInfowindow = false;
			let icon = false;

			if (attr.info_btn_url) {
				infoButtonString = '<p><a href="' + attr.info_btn_url + '" target="' + attr.info_btn_target + '">' + attr.info_btn + '</a></p>';
			}

			if (attr.image_src) {
				infoImageUrl = '<div class="side-gmap"><img src="' + attr.image_src + '" alt="' + attr.image_alt + '" /></div>';
			}

			if (attr.marker_svg_file) {
				icon = {
					url: attr.marker_svg_file,
					anchor: new google.maps.Point(20, 80),
					scaledSize: new google.maps.Size(40, 80),
				};
			}

			if (attr.info_text || attr.info_title) {
				let contentString =
					'<div class="map-infowindow">' +
					infoImageUrl +
					'<div class="main-gmap">' +
					'<h3 class="text-dark">' + attr.info_title + '</h3>' +
					'<div class="text-dark">' + attr.info_text +
					infoButtonString +
					'</div>' +
					'</div>' +
					'</div>';

				markerInfowindow = new google.maps.InfoWindow({
					content: contentString
				});
			}

			let marker = new google.maps.Marker({
				position: locLatLng,
				map: map,
				icon: icon ? icon : '',
				draggable: false,
				zIndex: -20,
				infowindow: markerInfowindow ? markerInfowindow : false,
			});

			markers.push(marker);

			marker.addListener('click', function () {
				hideAllInfoWindows(map);
				if (this.infowindow) {
					this.infowindow.open(map, this);
				}
				map.setCenter(this.getPosition());
				map.panTo(this.getPosition());

				if (offsetHeight) {
					map.panBy(0, -offsetHeight);
				}
			});

			map.panTo(marker.getPosition());

			if (offsetHeight && window.innerWidth > 768) {
				map.panBy(0, -offsetHeight);
			}

			bounds.extend(locLatLng);
		});

		map.setZoom(settings.zoom);
		if (Object.keys(settings.locations).length > 1) {
			map.fitBounds(bounds);
		}

		directionsRenderer.setMap(map);

		function hideAllInfoWindows(map) {
			markers.forEach(function (marker) {
				if (marker.infowindow) {
					marker.infowindow.close(map, marker);
				}
			});
		}

		function calculateAndDisplayRoute(origin, hotelPin, element) {
			return new Promise(
				(resolve, reject) =>
					directionsService.route(
						{
							origin: {
								query: origin,
							},
							destination: {
								query: hotelPin,
							},
							travelMode: google.maps.TravelMode.DRIVING,
						},
						(response, status) =>
							status === "OK"
								? resolve(response)
								: reject(status)
					)
			)
				.then(
					response => {
						directionsRenderer.setDirections(response);
						directionsRenderer.setMap(null);
						directionsRenderer.setMap(map);

						element.next('.tag-wrapper').find('.tag-distance span').html(response.routes[0].legs[0].distance.text);
						element.next('.tag-wrapper').find('.tag-time span').html(response.routes[0].legs[0].duration.text);
					},
					reject => console.log('Directions request failed due to ' + reject)
				);
		}

		const hotelPin = el.attr('data-pin-latitude') + ', ' + el.attr('data-pin-longitude');

		$('.map-order-title').on('click', function (ev) {
			ev.preventDefault();
			const $this = $(this);
			if ($this.parent().hasClass('is-open')) return;
			$this.parent().siblings().removeClass('is-open').find('.tag-wrapper').slideUp();
			$this.parent().addClass('is-open').find('.tag-wrapper').slideDown();
			calculateAndDisplayRoute(parseFloat($this.attr('data-lat')) + ', ' + parseFloat($this.attr('data-lng')), hotelPin, $this);
		});

		$('.map-order-title').eq(0).trigger('click');
	};

	/**
	 * Read More Toggler
	 */
	$.fn.readMoreToggler = function() {
		let readMoreToggle        = $( this ),
			entryContent          = $( readMoreToggle.attr( "data-toggle" ) ) ,
			entryContentHeight    = entryContent.height(),
			entryContentMaxHeight = readMoreToggle.attr( "data-max-height" );

		if ( entryContentHeight > entryContentMaxHeight ) {
			entryContent.css( "max-height", entryContentMaxHeight + "px" ).addClass( "faded" );
			readMoreToggle.removeClass( "d-none" );
			readMoreToggle.on(
				"click",
				function( e ) {
					e.preventDefault();
					$( this ).toggleClass( "toggled" );
					if ( $( this ).hasClass( "toggled" ) ) {
						$( this ).find( "span" ).text( $( this ).attr( "data-close-text" ) );
					} else {
						$( this ).find( "span" ).text( $( this ).attr( "data-open-text" ) );
					}
					entryContent.toggleClass( "toggled" );
				}
			);
		}
	};


	/**
	 * Photoswipe Lightbox
	 *
	 * @param options
	 */
	$.fn.photoswipeLightbox = function(options) {
		let el = $(this);

		let settings = $.extend({
			closeOnScroll: true,
			escKey: true,
			arrowKeys: true,
			loop: true,
			history: true,
			focus: true,
			modal: true,
			showHideOpacity: true,
			closeEl: true,
			captionEl: true,
			fullscreenEl: true,
			zoomEl: true,
			shareEl: true,
			counterEl: true,
			arrowEl: true,
			preloaderEl: true,
			bgOpacity: 0.7,
		}, options);

		el.each( function() {
			let $pic = $(this),
				getItems = function() {
					let items = [];
					$pic.find('a').each(function() {

						let $href = $(this).data('src'),
							$w = $(this).data('width'),
							$h = $(this).data('height'),
							$msrc = $(this).find('img').attr('src'),
							$title = $(this).data('title'),
							$pid = $(this).data('slug');

						let item = {
							src: $href,
							w: $w,
							h: $h,
							msrc: $msrc,
							title: $title,
							pid: $pid
						};

						items.push(item);

					});

					return items;

				};

			let items = getItems();

			let $pswp = $('.pswp')[0];
			$pic.on('click', 'a', function(event) {
				event.preventDefault();

				let $index = $(this).data('index');
				let options = {
					index: $index,
					bgOpacity: settings.bgOpacity,
					spacing: 0.12,
					allowPanToNext: true,
					pinchToClose: true,
					closeOnScroll: settings.closeOnScroll,
					closeOnVerticalDrag: true,
					escKey: settings.escKey,
					arrowKeys: settings.arrowKeys,
					history: settings.history,
					mouseUsed: false,
					loop: settings.loop,
					focus: settings.focus,
					modal: settings.modal,
					showHideOpacity: settings.showHideOpacity,
					showAnimationDuration: 333,
					hideAnimationDuration: 333,
					closeEl: settings.closeEl,
					captionEl: settings.captionEl,
					fullscreenEl: settings.fullscreenEl,
					zoomEl:  settings.zoomEl,
					shareEl:  settings.shareEl,
					counterEl: settings.counterEl,
					arrowEl: settings.arrowEl,
					preloaderEl:  settings.preloaderEl,
				};

				// Initialize PhotoSwipe
				let lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
				lightBox.init();
			});
		});
	};





	$.fn.scrollAnimations = function( options ) {
		/*
		 * Lets you apply one or more css transform functions to the selected elements.
		 * The value will depend on the position of the element.
		 * Given a starting value for when the element enters the screen and an end value for when it leaves.
		 * options can be given as parameter or set in html as data-smooth-scroll value.
		 * The format is {"property": propertyName,"start": startValue,"end": endValue}
		 * for example:
		 * <div data-smooth-scroll='{"property": "translateY","start":"180px","end":"-180px"}'>
		 * will make the div enter the screen 180px lower that its normal position and leave 180px higher,
		 * therefore it will scroll faster than the rest of the page.
		 * More than one transforms can be set on the same element as an array:
		 * <div data-smooth-scroll='[{"property": "translateY","start":"180px","end":"-180px"},{"property": "scale","start":"1","end":"1.45"}]'>
		 *
		 */


		// Helper function.
		// Get a number num that is between in_min and in_max and transform it into a number between out_min and out_max
		var scale = function(num, in_min, in_max, out_min, out_max) {
			return (num - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
		};

		// Helper function.
		// Takes a number with units (12px) and returns an array [12, 'px'].
		var parseUnit = function(str) {
			var output = [];
			str = String(str);
			output[0] = parseFloat(str);
			output[1] = str.match(/[\d.\-+]*\s*(.*)/)[1] || '';
			return output;
		};

		return this.each(function() {
			var $item = $(this);
			var $window = $(window);

			// Interpolate current value of transform.
			var getTransformValues = function($item) {

				var scrollPosition = $window.scrollTop();

				var element_height = $item.outerHeight();
				var element_top_position = $item.offset().top;
				var element_bottom_position = (element_top_position + element_height);

				var animationSettings;
				if ( $item.data('smooth-scroll') ) {
					animationSettings = $item.data('smooth-scroll');
				} else if (options) {
					animationSettings = options;
				}

				if ( $.isArray(animationSettings) ) {
					animationSettings.forEach(function(setting){
						var start = parseUnit(setting.start)[0];
						var end = parseUnit(setting.end)[0];
						var unit = parseUnit(setting.start)[1];
						var current = scale(scrollPosition, (element_top_position - $window.height()), element_bottom_position, start, end);
						setting.current = current.toString() + unit;
					});
				} else {
					var start = parseUnit(animationSettings.start)[0];
					var end = parseUnit(animationSettings.end)[0];
					var unit = parseUnit(animationSettings.start)[1];
					var current = scale(scrollPosition, (element_top_position - $window.height()), element_bottom_position, start, end);
					animationSettings.current = current.toString() + unit;
				}

				return animationSettings;
			};

			// Write interpolated value as transform property.
			var writeTransformProperty = function($item) {
				var value = '';
				var animationSettings = getTransformValues($item);

				if ( $.isArray(animationSettings) ) {
					animationSettings.forEach(function(setting) {
						var transform = setting.property + '(' + setting.current + ') ';
						value = value.concat(transform);
					});
				} else {
					value = animationSettings.property + '(' + animationSettings.current + ') ';
				}
				return value;
			};

			// Check if element is in view and write transform css.
			var runAnimations = function() {
				var window_height = $window.height();
				var window_top_position = $window.scrollTop();
				var window_bottom_position = (window_top_position + window_height);

				var element_height = $item.outerHeight();
				var element_top_position = $item.offset().top;
				var element_bottom_position = (element_top_position + element_height);

				if ((element_bottom_position >= window_top_position) && (element_top_position <= window_bottom_position)) {
					$item.css('transform', function() {
						return writeTransformProperty($item);
					});
				}
			};

			// Run animation on every scroll and resize.
			$window.on('scroll resize', runAnimations);
			$window.trigger('scroll');

			// Run animation on requestAnimationFrame.
			return this;
		});
	};

})(jQuery);

$(document).ready( function() {
	'use strict';

	let vh = window.innerHeight * 0.01;
	let allVH = document.querySelectorAll('.vh');

	allVH.forEach(function(el) {
		el.style.setProperty('--vh', vh + 'px');
	});

	window.addEventListener('resize', () => {
		let vh = window.innerHeight * 0.01;
		allVH.forEach(function(el) {
			el.style.setProperty('--vh', vh + 'px');
		});
	});

	/**
	 * Detect the current active responsive breakpoint in Bootstrap
	 * @returns {string}
	 * @author farside {@link https://stackoverflow.com/users/4354249/farside}
	 */
	function getResponsiveBreakpoint() {
		let envs = {xs:"d-none", sm:"d-sm-none", md:"d-md-none", lg:"d-lg-none", xl:"d-xl-none"};
		let env = "";

		let $el = $("<div>");
		$el.appendTo($("body"));

		for (let i = Object.keys(envs).length - 1; i >= 0; i--) {
			env = Object.keys(envs)[i];
			$el.addClass(envs[env]);
			if ($el.is(":hidden")) {
				break; // env detected
			}
		}
		$el.remove();
		return env;
	}

	$('[data-toggle="tooltip"]').tooltip();

	let readMoreToggle = $('.read-more-toggle');
	if (readMoreToggle.length > 0) {
		readMoreToggle.each(function() {
			$(this).readMoreToggler();
		});
	}

	/**
	 *  Scroll To Content Button
	 */
	let scrollDown = $('.scroll-down');
	let pageWrapper = $('#content');
	if (scrollDown.length > 0 && pageWrapper.length > 0) {
		scrollDown.on('click', function(e) {
			e.preventDefault();
			let offset = $('#wrapper-navbar').height();
			$('html, body').animate({
				scrollTop: pageWrapper.offset().top - offset
			}, 500);
		});
	}

	/**
	 * Scroll To Top Button
	 */
	let scrollTop = $('.scroll-top');
	if (scrollTop.length > 0) {
		$(window).on('scroll', function() {
			if ($(window).scrollTop() >= $('#content').offset().top) {
				scrollTop.addClass('d-lg-block');
			} else {
				scrollTop.removeClass('d-lg-block');
			}
		});
		scrollTop.on('click', function(e) {
			e.preventDefault();
			$('html, body').animate({
				scrollTop: $('body').offset().top
			}, 500);
		});
	}

	/**
	 * Masonry Gallery
	 */
	let $gallery = $('.masonry-gallery');
	if ($gallery.length > 0) {
		if ($gallery.data('isotope')) {
			/**
			 * init Isotope after all images have loaded
			 */
			$gallery.imagesLoaded().progress( function() {
				$gallery.isotope('layout');
			});

			/**
			 * Filter items on button click
			 */
			$('.masonry-gallery-filters:not(.last-sub-filters)').on('click', 'li a[data-filter]', function(ev) {
				ev.preventDefault();

				if (typeof preloader === 'function') {
					$gallery.find('.gallery-item').preloader({
						loader: '/app/themes/nelios-base/svg/loader/preloader.svg',
						fadeIn: 300,
						delay: 100
					});
				}

				$gallery.isotope({
					filter: $(this).attr('data-filter')
				});

				$(this).parent('li').siblings().find('a').removeClass('active');


				$( "#lvl3-li a" ).each(function( index ) {
					$(this).removeClass("active");
				})
				$( "#lvl2-li a" ).each(function( index ) {
					$(this).removeClass("active");
				})

				$(this).addClass('active');

				let n = document.querySelectorAll($(this).attr('data-filter')).length;
				let noProgrammes = document.querySelector('.no-program-error')
				if (n == 0) {
					noProgrammes.classList.add('d-block')
					noProgrammes.classList.remove('d-none')
				}else{
					noProgrammes.classList.remove('d-block')
					noProgrammes.classList.add('d-none')
				}


			});

			$gallery.isotope({
				filter: $('.masonry-gallery-filters:not(.last-sub-filters) li a[data-filter]').eq(0).attr('data-filter')
			});

			/**
			 * Filter items on button click
			 */

			$('.last-sub-filters.masonry-gallery-filters').on('click', 'li a[data-filter]', function(ev) {
				ev.preventDefault();
				if (typeof preloader === 'function') {
					$gallery.find('.gallery-item').preloader({
						loader: '/app/themes/nelios-base/svg/loader/preloader.svg',
						fadeIn: 300,
						delay: 100
					});
				}

				$gallery.isotope({
					filter: $(this).attr('data-filter')
				});

				$(this).parent('li').siblings().find('a').removeClass('active');
				$(this).addClass('active');
			});

			$gallery.isotope({
				filter: $('.last-sub-filters.masonry-gallery-filters li a[data-filter]').eq(0).attr('data-filter')
			});


		} else if ($gallery.data('masonry')) {
			$gallery.imagesLoaded().progress( function() {
				$gallery.isotope('layout');
			});
		}

		if ($gallery.data('photoswipe-options')) {
			$gallery.photoswipeLightbox($gallery.data('photoswipe-options'));

			/**
			 * Lightbox All Link
			 */
			$gallery.parent().find('.masonry-gallery-all-link').click(function(event){
				event.preventDefault();
				// $gallery.find('.gallery-item:first').trigger("click");

				if (typeof preloader === 'function') {
					console.log('init preloader');
					$gallery.find('.gallery-item').preloader({
						loader: '/app/themes/nelios-base/svg/loader/preloader.svg',
						fadeIn: 300,
						delay: 100
					});
				}
				$gallery.find('.gallery-item.d-none').removeClass('d-none');
				$(this).hide();
				$gallery.isotope('layout');
			});
		}
	}

	let $mediaCategories = $('.media-categories');

	if ( $mediaCategories.length > 0 ) {
		$( '.media-category' ).on( 'click', function( ev ) {
			ev.preventDefault();
			let targetElement = this.dataset.target;
			$(this).addClass('active').parent().siblings().find('a').removeClass('active');
			$( '.' + targetElement ).show().siblings().hide();
		});
	}


	/**
	 * Google Map
	 */
	let $map = $('.map');
	if ($map.length > 0) {
		let elMap = $map;
		elMap.googleMap(elMap.data('json'));

		$map = elMap;
	}

	/*
	* Main menu trigger
	*/
	let $dots = $('.menu-bar:not(.sticky) .dots-menu-btn');
	let $dotsSticky = $('.menu-bar.sticky .dots-menu-btn');

	$dots.on('click', function(ev) {
		if (!$('body').hasClass('open-menu')) {
			openMainMenu();
		} else {
			closeMainMenu();
		}
	});

	$dotsSticky.on('click', function(ev) {
		if (!$('body').hasClass('open-menu')) {
			openMainMenu(true);
		} else {
			closeMainMenu(true);
		}
	});

	$(document).keyup(function(e) {
		if (e.keyCode === 27) closeMainMenu();
	});

	function openMainMenu(isSticky = false) {
		let $fullCircle;
		let dotsPosition;
		let windowHypotenuse = Math.hypot(window.innerWidth, window.innerHeight);
		let $menuTag;

		$('body').addClass('open-menu');

		$fullCircle = $('.wrapper-navbar .full-circle');
		if ( false === isSticky ) {
			dotsPosition = $dots.find('svg').get(0).getBoundingClientRect();
			$fullCircle.css('top', dotsPosition.top + (dotsPosition.width/2) - ($fullCircle.innerWidth()/2));
			$fullCircle.css('left', dotsPosition.left + (dotsPosition.width/2) - ($fullCircle.innerWidth()/2));
			$menuTag = $dots.find('.menu-tag');
			$dots.closest('.right-area').find('.book-now.button').removeClass('button-style-1').addClass('button-style-2');
		} else {
			// $fullCircle = $('.wrapper-navbar .container.sticky .full-circle');
			dotsPosition = $dotsSticky.find('svg').get(0).getBoundingClientRect();
			$fullCircle.css('top', dotsPosition.top + (dotsPosition.width/2) - ($fullCircle.innerWidth()/2));
			$fullCircle.css('left', dotsPosition.left + (dotsPosition.width/2) - ($fullCircle.innerWidth()/2));
			$menuTag = $dotsSticky.find('.menu-tag');
		}

		let fullCircleDiameter = $fullCircle.innerWidth();
		let calculatedScale = Math.ceil(windowHypotenuse / fullCircleDiameter) * 2;
		$fullCircle.get(0).style.setProperty('--circle-scale', calculatedScale);

		gsap.to('.js-menu-background-image', {duration: .3, opacity: 1});
		gsap.to($menuTag, {duration: .4, y: '100%'});
		gsap.to($menuTag.find('.closing-label'), {duration: .3, opacity: 1});
		gsap.to($menuTag.find('.opening-label'), {duration: .3, opacity: 0});
		gsap.to('.primary-menu > .menu-item', {duration: .5, opacity: 1, y: 0, ease: Expo.easeOut, stagger: 0.07 });
		gsap.to('.js-navbar-footer', {duration: .5, y: '0', ease: Expo.easeInOut, delay: .2});
	}

	function closeMainMenu(isSticky = false) {
		let $menuTag = false === isSticky ? $dots.find('.menu-tag') : $dotsSticky.find('.menu-tag');
		gsap.to('.js-navbar-footer', {duration: .4, y: '100%', ease: Expo.easeIn});
		gsap.to($menuTag, {duration: .4, y: '0%', delay: .5});
		gsap.to($menuTag.find('.closing-label'), {duration: .3, opacity: 0, delay: .5});
		gsap.to($menuTag.find('.opening-label'), {duration: .3, opacity: 1, delay: .5});
		gsap.to('.primary-menu > .menu-item', {duration: .3, opacity: 0, y: '-10px', ease: Expo.easeInOut});
		gsap.to('.js-menu-background-image', {duration: .3, opacity: 0});

		if ( false === isSticky ) {
			$dots.closest('.right-area').find('.button.button-style-2').removeClass('button-style-2').addClass('button-style-1');
		}

		$('body').removeClass('open-menu');
	}

	let $mouseFollower = $('.mouse-follower');

	function moveCursor(ev) {
		TweenLite.to($mouseFollower, {duration: 1, left: ev.clientX, top: ev.clientY});
	}

	function hoverOverLinks(ev) {
		TweenLite.to($mouseFollower, {duration: 0.3, opacity: 0, scale: 0.3});
	}

	function unhoverOverLinks(ev) {
		TweenLite.to($mouseFollower, {duration: 0.3, opacity: 1, scale: 1});
	}

	$(window).on('mousemove', moveCursor);
	$('a, .btn, .button, button, .link, .hide-cursor').not('.show-cursor').hover(hoverOverLinks, unhoverOverLinks);
	$('.show-cursor').hover(function(ev) {
		if ( $(this).hasClass('show-drag')) {
			$mouseFollower.addClass('show-drag');
			// } else {
			// 	$mouseFollower.removeClass('show-drag')
		}
	}, function(ev) {
		$mouseFollower.removeClass('show-drag');
	});

	$('.nav-link[aria-haspopup]').on('click', function (ev) {

		let $this = $(this);

		if ( $this.attr('aria-expanded') === 'true' ) {
			return;
		}

		ev.preventDefault();

		$this.closest('.primary-menu').find('[aria-expanded="true"]').not($this).each(function(index, element) {
			let $element = $(element);
			$element.attr('aria-expanded', 'false');
			$element.next('ul.sub-menu').removeClass('open').slideUp();
		});

		let $subMenu = $this.next('ul.sub-menu');

		if ( !$subMenu.hasClass('open')) {
			$this.attr('aria-expanded', 'true');
			$subMenu.addClass('open').slideDown();
		} else {
			$this.attr('aria-expanded', 'false');
			$subMenu.removeClass('open').slideUp();
		}
	});

	window.container = $('.menu-bar:not(.sticky)');
	window.containerSticky = $('.menu-bar.sticky');

	$('.nav-link[aria-haspopup]').hover(function (ev) {
		if ( window.innerWidth >= 1440 ) {
			if ($(this).attr('aria-expanded') !== 'true') {
				$(this).trigger('click');
			}
		}
	});


	/**
	 * Timeline Slider
	 *
	 */

	let $timelineSlider = $('.timeline-slider');

	$timelineSlider.each((index, slider) => {
		const $timelineIndicators       = $timelineSlider.find( '.slider-navigation li' );
		let $timelineBackgroundsWrapper = $timelineSlider.find( '.backgrounds-wrapper' );
		let slideIndex                  = 1;
		let timer;

		function plusSlides(n) {
			showSlides( slideIndex += n );
		}

		function showSlides(n) {
			if (n > $timelineIndicators.length) {
				slideIndex = 1;
			}

			if (n < 1) {
				slideIndex = $timelineIndicators.length - 1;
			}

			$timelineIndicators.eq( slideIndex - 1 ).trigger( 'click' );
		}

		$timelineIndicators.on('click', function () {

			if ( 960 > $(window).width() ) return;

			const $this = $(this);
			if ( $this.hasClass( 'current' ) ) return;

			slideIndex = $timelineIndicators.index(this) + 1;

			$timelineIndicators.each((i, e) => {
				e.classList.remove('active');
				e.classList.remove('current');
			})

			$this.prevAll().addClass('active');
			$this.addClass('current');
			clearTimeout(timer);
			timer = setTimeout(() => {
				$this.removeClass('current').addClass('active');
				plusSlides(1);
			}, 2000);

			const $target  = $timelineBackgroundsWrapper.find('.slide-background[data-slide-id="' + this.dataset.slideId + '"]');
			const $current = $timelineBackgroundsWrapper.find('.slide-background.active');

			$target.siblings().css('z-index', '-2').removeClass('active');
			$current.css('z-index', '-1');
			$target.css('z-index', '1').addClass('active');

			TweenLite.fromTo($target.get(0), {opacity: 0}, {duration: 0.5, ease: Expo.easeInOut, opacity: 1});
		})

		// Enable Transition
		$timelineIndicators.eq(0).trigger('click');
	});

	// let flowerCirlce = document.querySelector('.circleslider')
	// function setFlowerCircleSize() {
	// 	const tl = new TimelineLite({
	// 		repeat: -1
	// 	}).to(flowerCirlce, {
	// 		duration: 20,
	// 		rotation: 360,
	// 		ease: Linear.easeNone
	// 	})
	// }



	let isMenuWorking = false;

	function showSmallMenuBar() {
		isMenuWorking = true;
		window.containerSticky.addClass('active');
		gsap.to(window.container, {duration: 0.3, y: '-103%'});
		gsap.to(window.containerSticky, {duration: 0.3, y: 0, delay: 0.3, onComplete: () => {
				isMenuWorking = false;
			}});
	}

	function showNormalMenuBar() {
		isMenuWorking = true;
		gsap.to(window.containerSticky, {duration: 0.3, y: '-103%'});
		gsap.to(window.container, {duration: 0.3, y: 0, delay: 0.3, onComplete: () => {
				isMenuWorking = false;
			}});
		window.containerSticky.removeClass('active');
	}

	let debounce_timer;
	$(window).on('scroll', function() {
		if(debounce_timer) {
			window.clearTimeout(debounce_timer);
		}
		debounce_timer = window.setTimeout(() => {
			if (document.body.classList.contains('page-small-menu-bar')) return;

			if ( isMenuWorking ) return;

			let pageYOffset = window.pageYOffset || document.body.scrollTop;

			if (100 < pageYOffset) {
				showSmallMenuBar();
			} else {
				showNormalMenuBar();
			}
		}, 250);
	});

	$(window).resize();

	$(window).trigger('scroll');

	const events = THEME_OBJ.events;
	const dates  = [];

	if ( events && ! document.body.classList.contains('page-template-press') && ! document.body.classList.contains('blog') ) {
		for (const el of events) {
			if ( typeof el['date_time'] !== 'undefined' ) {
				dates.push( new Date( el['date_time'].date.replace(/ /g,"T") ) );
			}
		}
	}

	function isSameDay(d1, d2) {
		return d1.getFullYear() === d2.getFullYear() &&
			d1.getDate() === d2.getDate() &&
			d1.getMonth() === d2.getMonth();
	}

	$.fn.datepicker.language['en'] = {
		days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
		daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
		months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
		monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		today: 'Today',
		clear: 'Clear',
		dateFormat: 'dd.mm.yyyy',
		timeFormat: 'hh:ii aa',
		firstDay: 0
	};

	$.fn.datepicker.language['el'] = {
		days: ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο'],
		daysShort: ['Κυρ', 'Δευ', 'Τρι', 'Τετ', 'Πεμ', 'Παρ', 'Σαβ'],
		daysMin: ['Κυ', 'Δε', 'Τρ', 'Τε', 'Πε', 'Πα', 'Σα'],
		months: ['Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάϊος', 'Ιούνιος', 'Ιούλιος', 'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος'],
		monthsShort: ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μαϊ', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'],
		today: 'Σήμερα',
		clear: 'Καθαρισμός',
		dateFormat: 'dd.mm.yyyy',
		timeFormat: 'hh:ii aa',
		firstDay: 0
	};

	$.fn.datepicker.language['de'] = {
		days: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
		daysShort: ['Sonn', 'Mon', 'Dien', 'Mitt', 'Donn', 'Fre', 'Sam'],
		daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
		months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
		monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
		today: 'Heute',
		clear: 'Klar',
		dateFormat: 'dd.mm.yyyy',
		timeFormat: 'hh:ii aa',
		firstDay: 0
	};

	$.fn.datepicker.language['fr'] = {
		days: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
		daysShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
		daysMin: ['Ms', 'De', 'Tr', 'Te', 'Ven', 'Pa', 'Sa'],
		months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
		monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		today: 'Aujourd hui',
		clear: 'Nettoyage',
		dateFormat: 'dd.mm.yyyy',
		timeFormat: 'hh:ii aa',
		firstDay: 0
	};

	const $eventTemplate = $('#event-list-template').children();
	const $eventList     = $('.events-list ul');

	$( '.calendar-box .datepicker-placeholder' ).datepicker({
		'inline': true,
		'language': THEME_OBJ.language_code || 'en',
		'keyboardNav': false,
		'toggleSelected': false,
		// 'showOtherMonths': false,
		// 'selectOtherMonths': false,
		'navTitles': {
			'days': '<span class="month-number">mm.</span> MM',
		},
		onRenderCell: function (date, cellType) {
			if ( 'day' !== cellType ) return;

			for ( const d of dates) {
				if ( isSameDay( d, date ) ) {
					return {
						classes: 'event-span-cell'
					};
				}
			}

			if ( isSameDay( date, new Date() ) ) {
				return {
					html: date.getDate() + '<span class="bullet"></span>'
				};
			}
		},
		onSelect: function onSelect(formattedDate, date) {
			$eventList.empty();
		}
	});

	const wpcf7Form = document.querySelector( '.wpcf7' );

	if ( wpcf7Form ) {
		wpcf7Form.addEventListener( 'wpcf7invalid', function( event ) {
			console.log( 'JavaScript wpcf7invalid...' );
		}, false );
	}

	document.querySelectorAll( '.calendar-box .datepicker-placeholder' ).forEach( placeholder => {
		placeholder.addEventListener( 'click', function() {
			document.querySelectorAll( '.datepicker--cell-day' ).forEach ( cell => {
				if ( cell.childNodes.length > 1 ) {
					if ( cell.children[0].classList.contains( 'bullet-white' ) ) {
						cell.classList.add( 'event-span-cell' );
					}
				}
			});
		})
	})

	$('.js-title-row').on('click', function(ev) {
		$(this).next().slideToggle();
	});


	let $room_gallery = $( '.single-room [data-photoswipe-options]' );

	if ( 0 < $room_gallery.length ) {
		$room_gallery.photoswipeLightbox( $room_gallery.data( 'photoswipe-options' ) );
	}

	let $gallery_mini = $('.gallery-mini-content');
	if ( $gallery_mini.length > 0 ) {
		$gallery_mini.photoswipeLightbox( $gallery_mini.data('photoswipe-options'));
	}



	let readMoreToggleLink = $( '.read-more-toggle-link' );
	// if ( readMoreToggleLink.length > 0 ) {
	// 	readMoreToggleLink.readMoreToggler();
	// }
	if (readMoreToggleLink.length > 0) {
		readMoreToggleLink.each(function() {
			$(this).readMoreToggler();
		});
	}

	// const directionsService  = new google.maps.DirectionsService();
	// const directionsRenderer = new google.maps.DirectionsRenderer();
	//
	// directionsRenderer.setMap($map);



	$('a[data-cat-map]').on('click', function(ev) {
		ev.preventDefault();

		$('.map-tab-content').removeClass('is-active').find('.map-item-order').removeClass('is-open');
		$('.map-tab-content[data-cat-map="' + $(this).attr('data-cat-map') + '"]').addClass('is-active');

		$(this).addClass('active').parent().siblings().find('a').removeClass('active');
	});



	$('[data-sub-id]').on('click', function(ev) {

		ev.preventDefault();
		let $target = $('[data-id="' + $(this).attr('data-sub-id') + '"]');

		$('[data-id]').removeClass('active');
		$('[data-id-id]').removeClass('active');

		$target.addClass('active').find('a').removeClass('active');

	});

	// $('[data-parent]').on('click', function(ev) {
	//
	// 	let $target = $('[data-id-id="' + $(this).attr('data-parent') + '"]');
	//
	// 	$('[data-id-id]').removeClass('active');
	//
	// 	$target.addClass('active').find('a').removeClass('active');
	//
	// });

	$('[data-clear-subs]').on('click', function(ev) {
		$('[data-id]').removeClass('active');
	});

	let $programme_dates = $('[name="accommodation_date"]');

	if ( 0 < $programme_dates.length ) {
		$programme_dates.datepicker({
			'minDate': new Date(),
			'language': THEME_OBJ.language_code || 'en',
			'keyboardNav': false,
			'toggleSelected': false,
			'dateFormat': 'dd/mm/yyyy',
			'range': true,
			'multipleDatesSeparator': ' - ',
			'maxDate': new Date(2021, 11, 31)
		});
	}

	$('.js-open-booking-programme').on('click', function(ev) {
		ev.preventDefault();
		$(this).closest('.book-package-wrapper').find('.book-package-form-wrapper').slideDown();
		$(this).fadeOut(300);
	});

	$('.full-width-slider .slider-wrapper').on('click', 'a', function(ev) {
		if ( ! $( this ).closest( '.slide' ).hasClass( 'is-selected' ) ) {
			ev.preventDefault();
			var flkty = Flickity.data( $( '.the-slider' )[0] );
			flkty.selectCell( $('.full-width-slider a').index(this) - 1 );
		}
	});

	let isAjax = false;
	$('.js-load-more-awards').on('click', ev => {
		ev.preventDefault();
		const $this = $(ev.currentTarget);

		if ( isAjax ) return false;

		console.log('+++++++');
		isAjax = true;
		$this.addClass('disabled');
		const originalLabel = $this.text();
		const page = parseInt( $this.get(0).dataset.page );
		$this.text( $this.data('loading'));
		const $target = $($this.attr('data-target'));

		$.ajax( {
			url: THEME_OBJ.ajaxURL,
			type: 'post',
			data: {
				action: $this.get(0).dataset.action,
				nonce: $this.get(0).dataset.nonce,
				offset: $this.get(0).dataset.offset || 0,
				post_id: $this.get(0).dataset.postId || 0,
				posts_per_page: $this.get(0).dataset.perPage || 4,
				category: $this.get(0).dataset.category,
				page: $this.get(0).dataset.page || 2,
			},
			success( data ) {
				if ( data ) {
					const d = JSON.parse(data);
					$target.append( d.html );
					if ( true === d.is_last ) {
						//$this.remove();
						ev.currentTarget.classList.add("d-none");
					} else {
						$this.get(0).setAttribute('data-offset', d.new_offset);
						$this.get(0).setAttribute('data-page', page + 1 );
					}


				}
			},
			complete() {
				isAjax = false;
				$this.removeClass('disabled');
				$this.text( originalLabel );
			}
		} );
	}).on('mousedown', ev => {
		ev.preventDefault();
	});

	if (document.body.classList.contains('page-small-menu-bar')) {
		showSmallMenuBar();
	}

	const $heroVideo = $('#hero-video');
	if ( $heroVideo.length > 0) {
		const mediaVideo = $heroVideo.get(0);
		const $btnMute = $('.js-video-controls .mute-control');
		const $btnPause = $('.js-video-controls .pause-control');

		$btnPause.on('click', ev => {
			if (mediaVideo.paused) {
				mediaVideo.play();
				$btnPause.find('.icon').removeClass('stop');
			} else {
				mediaVideo.pause();
				$btnPause.find('.icon').addClass('stop');
			}
		});
		$btnMute.on('click', ev => {
			if (mediaVideo.muted) {
				$btnMute.find('.icon').addClass('stop');
			} else {
				$btnMute.find('.icon').removeClass('stop');
			}
			mediaVideo.muted = !mediaVideo.muted;
		});

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					mediaVideo.pause();
					$btnPause.find('.icon').addClass('stop');
				} else {
					mediaVideo.play();
					$btnPause.find('.icon').removeClass('stop');
				}
			});
		}, {});

		observer.observe(mediaVideo);
	}


	const $heroImage = $('.hero-image');
	const $videoPopup = $('.popup-video');

	if ( $heroImage.length > 0 && $videoPopup.length > 0 ) {
		const $playBtn = $('.play-video-icon-wrapper');
		$playBtn.on('click', ev => {
			const $target = $($(ev.target).data('target'));
			const videoElement = $target.find('video').get(0);
			$target.addClass('active');
			videoElement.play();

			$target.find('.closing-x').on('click', ev => {
				videoElement.pause();
				$target.removeClass('active');
			});
		});
	}

	$(".tab-title").click(function() {
		// Remove the 'active' class from all tabs and tab contents
		$(".tab-title").removeClass("active");
		$(".tab-content").removeClass("active");

		// Add the 'active' class to the clicked tab and corresponding content
		$(this).addClass("active");
		$(".tab-content").eq($(this).index()).addClass("active");
	});
});

// below apply scroll on target div for post new content with id
var url = window.location.href;
if (url.indexOf("#") > -1) {
	var anchor = url.substring(url.indexOf("#") + 1);
	if ( 'undefined' !== typeof $(".scroll-post-" + anchor).offset() && !isNaN(anchor)) {
		var targetScrollPos = $(".scroll-post-" + anchor).offset().top - 110;
		$("html, body").animate({ scrollTop: targetScrollPos }, 500);
	}
}

setTimeout(() => {
	// Function to apply scroll on target div for post new content with id
	function scrollToTargetDiv() {
		var urlHash = window.location.hash;
		var number = urlHash.slice(1);
		var targetDiv = document.querySelector('.scroll-post-' + number);
		if (targetDiv) {
			targetDiv.scrollIntoView({ behavior: 'smooth' });
			var headerHeight = 110;
			var scrollPosition = window.pageYOffset - headerHeight + 2;
			window.scrollTo({
				top: scrollPosition,
				behavior: 'smooth'
			});
		}
	}
	document.addEventListener('DOMContentLoaded', function () {
		if (window.location.hash) {
			scrollToTargetDiv();
		}
	});
	window.addEventListener('hashchange', scrollToTargetDiv);
}, 300);


$(window).on('resize orientationchange', function() {
});

function canUseWebP() {
	var elem = document.createElement('canvas');
	if (!!(elem.getContext && elem.getContext('2d'))) {
		// was able or not to get WebP representation
		return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
	}
	// very old browser like IE 8, canvas not supported
	return false;
}

$( document ).ready( function() {
	let bgImageElements = $('*[data-parallax-background-image-url]');
	if (bgImageElements.length > 0) {
		bgImageElements.each(function() {
			let bgImageElement = $(this);
			let bgImageElementUrl = bgImageElement.attr('data-parallax-background-image-url');
			if (bgImageElementUrl) {
				if ( canUseWebP() ) {
					bgImageElement.css('background-image', `url(${bgImageElementUrl})`);
				} else {
					bgImageElementUrl = bgImageElementUrl.replace('.webp','');
					bgImageElement.css('background-image', `url(${bgImageElementUrl})`);
				}
			}
		});
	}
});

$( document ).ready( function() {
	if (document.body.classList.contains('page-template-programmes')) {
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});
		let programmesTab = params.tab;
		let tabs = document.querySelectorAll('.masonry-gallery-filters li a[data-sub-id],a[data-clear-subs]');
		if (programmesTab != null) {
			if (tabs != null) {
				for ( i = 0; i < tabs.length; i++ ) {
					if (tabs[i].querySelector('span').textContent.toLowerCase().trim() == programmesTab.toLowerCase().trim()) {
						tabs[i].click();
						break;
					}
				}
			}
		}
		function tabToUrlParameter(e) {
			return function(){
				let param = e.replace(/^\s*$(?:\r\n?|\n)/gm, "");
				var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?tab=' + param.trim();
				window.history.pushState({ path: refresh }, '', refresh);
			}
		}
		if (tabs != null) {
			for (i = 0; i < tabs.length; i++) {
				tabs[i].addEventListener("click", tabToUrlParameter(tabs[i].querySelector('span').textContent.toLowerCase()), false);
			}
		}
	}

	let eventList = $('#event-list-template');
	let eventPickerBtns = $('.datepicker--nav-action').data("prev");

	if ( eventList ) {

		function checkForEvents() {
			let lis = $('li.event');
			let month = $('.month-number').text();
			month = Number(month.replace('.', ''));
			//console.log(month);
			lis.each(function() {
				//console.log($( this ).data("date"))
				if ( month === Number($( this ).data("date"))) {
					$( this ).removeClass('d-none');
				}
				else {
					$( this ).addClass('d-none');
				}
			});

		}

		function hookEventsInCalendarButtons() {
			checkForEvents();
			document.querySelectorAll('.datepicker--nav-action').forEach (el => {
				el.addEventListener('click', function (){
					checkForEvents();
					setTimeout(() => {
						reInitEvents();
					}, 200);
				});
			});
		}

		function reInitEvents() {
			hookEventsInCalendarButtons();
		}

		hookEventsInCalendarButtons();

		setTimeout(() => {
			checkForEvents();
		}, 200);


	}
});


$( document ).ready( function() {

	let presents = document.querySelectorAll(".present");
	let overlays = document.querySelectorAll(".present .description");

	for (let i = 0; i < presents.length; i++) {
		presents[i].addEventListener('click', enableOverlay);
	}

	function enableOverlay() {
		closeOverlays();
		this.querySelector('.description').style.display = 'block';
		this.style.pointerEvents = "none";
	}

	function closeOverlays() {
		for ( let i = 0; i < overlays.length; i++ ) {
			overlays[i].style.display = 'none';
			presents[i].style.display = 'block';
			presents[i].style.pointerEvents = 'auto';
		}
	}

	document.addEventListener('mouseup', function(e) {
		let clicked_present = false;
		for (let i = 0; i < presents.length; i++) {
			if (presents[i].contains(e.target)) {
				clicked_present = true;
				break;
			}
		}
		if (!clicked_present) {
			closeOverlays();
		}
	});

	if (document.body.classList.contains('single-programme')) {

		let book_select = document.querySelector('.booking-custom-select');
		let book_select_items =  document.querySelectorAll('.booking-custom-select li');

		if (book_select && book_select_items.length != 0) {
			let book_selected = document.querySelector('.booking-custom-selected');
			let book_arrow = document.querySelector('.booking-custom-arrow');
			let book_request_btn = document.querySelector('.book-request');
			let book_request_btn_mobile = document.querySelector('.book-request-mobile');

			let online_reserve_link = document.querySelector('.booking-custom-selected').getAttribute('reserve-link');
			let label_length = document.querySelector('#date_length');
			let label_price = document.querySelector('#date_price');

			book_selected.innerHTML = book_select_items[0].innerHTML;
			let nights = book_select_items[0].getAttribute('nights');
			let offerID = book_select_items[0].getAttribute('offerid');
			let build_link = online_reserve_link + "&checkin=" + book_select_items[0].getAttribute('value') + "&rooms=1&nights=" + nights + "&adults=1&offerid=" + offerID;

			build_link = book_select_items[0].getAttribute('override-link') ?? build_link;

			if (book_request_btn) {
				book_request_btn.setAttribute('href', build_link);
			}

			if (book_request_btn_mobile) {
				book_request_btn_mobile.setAttribute('href', build_link);
			}

			label_price.innerHTML = book_select_items[0].getAttribute('label-price');
			label_length.innerHTML = book_select_items[0].getAttribute('label-nights');

			if (book_select_items.length > 1) {

				book_selected.addEventListener('click', function () {
					book_select.classList.remove('d-none');
					book_select.classList.add('d-flex');
					book_arrow.classList.add('open');
				})

				book_arrow.addEventListener('click', function () {
					book_select.classList.toggle('d-none');
					book_select.classList.toggle('d-flex');
					book_arrow.classList.toggle('open');
				})

				for (let i = 0; i < book_select_items.length; i++) {
					book_select_items[i].addEventListener('click', function () {
						for (let j = 0; j < book_select_items.length; j++) {
							book_select_items[j].classList.remove('order-first');
						}
						book_selected.innerHTML = book_select_items[i].innerHTML;
						let nights = book_select_items[i].getAttribute('nights');
						let offerID = book_select_items[i].getAttribute('offerid');
						let build_link = online_reserve_link + "&checkin=" + book_select_items[i].getAttribute('value') + "&rooms=1&nights=" + nights + "&adults=1&offerid=" + offerID;
						build_link = book_select_items[i].getAttribute('override-link') ?? build_link;

						if (book_request_btn) {
							book_request_btn.setAttribute('href', build_link);
							book_request_btn_mobile.setAttribute('href', build_link);
						}

						label_price.innerHTML = book_select_items[i].getAttribute('label-price');
						label_length.innerHTML = book_select_items[i].getAttribute('label-nights');

						book_select_items[i].classList.add('order-first');
						book_select.classList.add('d-none');
						book_select.classList.remove('d-flex');
						book_arrow.classList.remove('open');
					})
				}

				document.addEventListener('mouseup', function (e) {
					let clicked_select = false;

					let select_element1 = document.querySelector('.booking-custom-selected');
					let select_element2 = document.querySelector('.booking-custom-select');
					let select_element3 = document.querySelector('.booking-custom-arrow');

					if (select_element1.contains(e.target) || select_element2.contains(e.target) || select_element3.contains(e.target)) {
						clicked_select = true;
					}
					if (!clicked_select) {
						book_select.classList.add('d-none');
						book_select.classList.remove('d-flex');
						book_arrow.classList.remove('open');
					}
				});
			}
		}

		document.querySelectorAll('.treatment-modal-show').forEach( btn => {
			btn.addEventListener('click', function(e) {
				let modal = e.target.parentElement.querySelector('.treatment-modal');
				modal.style.right = '0vw';
			});
		});
		document.querySelectorAll('.treatment-modal').forEach( modal => {
			modal.addEventListener('click', function(e) {
				console.log(e.target.className);
				if (e.target.classList.contains('treatment-modal') || e.target.classList.contains('content-container')) {
					modal.style.right = '-100vw';
				}
			});
		});
		if ( window.innerWidth < 768 ) {
			const closeModalButtons = document.querySelectorAll('.modal-close');
			closeModalButtons.forEach(closeModalButton => {
				closeModalButton.addEventListener('click', () => {
					const modal = closeModalButton.closest('.treatment-modal');
					if (modal) {
						modal.classList.add('hidden-modal');
						modal.style.right = '-100vw';
					}
				});
			});
		}
		document.querySelectorAll('.modal-close').forEach( btn => {
			btn.addEventListener('click', function(e) {
				let modal = btn.parentElement.parentElement.parentElement.querySelector('.treatment-modal');
				modal.style.right = '-100vw';
			});
		});
		document.querySelectorAll('.next-treatment').forEach( btn => {
			btn.addEventListener('click', function(e) {
				const target = e.target.dataset.target;
				const index = e.target.dataset.index;

				const currentModal = document.getElementById(`treatment-modal-${index}`);
				const targetModal = document.getElementById(`treatment-modal-${target}`);

				if (currentModal)
					currentModal.style.right = '-100vw';

				if(targetModal)
					targetModal.style.right = '0vw';

			});
		});
		document.querySelectorAll('.next-treatment-mobile').forEach( btn => {
			btn.addEventListener('click', function(e) {
				const target = e.target.dataset.target;
				const index = e.target.dataset.index;

				const currentModal = document.getElementById(`treatment-modal-mobile-${index}`);
				const targetModal = document.getElementById(`treatment-modal-mobile-${target}`);

				if (currentModal)
					currentModal.style.right = '-100vw';

				if(targetModal)
					targetModal.style.right = '0vw';

			});
		});

	}

	if (document.body.classList.contains('blog') || document.body.classList.contains('page-template-press') ) {

		let galleryFilters = document.querySelectorAll('.masonry-gallery-filters li')
		let isAjax = false;
		let category_active = document.querySelector('.masonry-gallery-filters li a.active');
		let subcategory_active = null;
		let loadmore_btn = document.querySelector('.load-more.js-load-more-awards');
		const loaderWrapper = document.querySelector('.loader-wrapper');
		const offerListWrapper = document.querySelector('.offer-list-wrapper');

		for (let i=0; i < galleryFilters.length; i++) {
			galleryFilters[i].addEventListener('click', function(ev) {
				ev.preventDefault();
				const $this = $(ev.currentTarget);

				if ( isAjax ) return false;

				isAjax = true;
				if (loaderWrapper) {
					loaderWrapper.classList.add('active');
				}
				if (offerListWrapper) {
					offerListWrapper.classList.add('active');
				}

				//$this.addClass('disabled');
				if (ev.currentTarget.classList.contains("main-category")) {
					category_active.classList.remove('active');
					ev.currentTarget.querySelector('a').classList.add("active");
					category_active = ev.currentTarget.querySelector('a');
					// if (subcategory_active !== null) {
					// 	subcategory_active.classList.remove("active");
					// }
					// subcategory_active = ev.currentTarget.querySelector('ul li:first-child a');
					// subcategory_active.classList.add("active");
				}
				else {
					if (subcategory_active !== null) {
						subcategory_active.classList.remove("active");
					}
					subcategory_active = ev.currentTarget.querySelector('a');
					subcategory_active.classList.add("active");
				}


				const originalLabel = $this.text();
				const page = parseInt( $this.get(0).dataset.page );
				//$this.text( $this.data('loading'));
				const $target = $($this.attr('data-target'));

				$.ajax( {
					url: THEME_OBJ.ajaxURL,
					type: 'post',
					data: {
						action: $this.get(0).dataset.action,
						nonce: $this.get(0).dataset.nonce,
						offset: $this.get(0).dataset.offset || 0,
						post_id: $this.get(0).dataset.postId || 0,
						posts_per_page: $this.get(0).dataset.perPage || 4,
						category: $this.get(0).dataset.category,
						page: 1
					},
					success( data ) {
						if ( data ) {
							const d = JSON.parse(data);
							$target.html('');
							$target.append( d.html );
							if ( true === d.is_last ) {
								//$this.remove();
								loadmore_btn.classList.add("d-none");
							} else {
								//$this.get(0).setAttribute('data-offset', d.new_offset);
								//$this.get(0).setAttribute('data-page', page + 1 );
								loadmore_btn.classList.remove('d-none');
								loadmore_btn.setAttribute('data-category',$this.get(0).dataset.category);
								loadmore_btn.setAttribute('data-page',2);
							}


						}
					},
					complete() {
						isAjax = false;
						if (loaderWrapper) {
							loaderWrapper.classList.remove('active');
						}
						if (offerListWrapper) {
							offerListWrapper.classList.remove('active');
						}

						//$this.removeClass('disabled');
						//$this.text( originalLabel );
					}
				} );

			})
		}
	}

	if ( document.body.classList.contains('page-template-calendar') || document.body.classList.contains('page-template-programmes') ) {

		let allEvents = document.querySelector('.events-filters .all-events');

		function fixMasonry() {
			let $gallery = $('.masonry-gallery');
			if ($gallery.length > 0) {
				if ($gallery.data('isotope')) {
					$gallery.isotope('layout');
				}
			}
		}

		allEvents.addEventListener('click', function (ev) {
			ev.preventDefault();

			let events = document.querySelectorAll('.events-filters .calendar-event');

			events.forEach( event => {
				event.classList.remove('d-none')
				event.classList.add('d-block')

				document.querySelector('.events-filters .month-select .selected-value').innerHTML = "Month";
				document.querySelector('.events-filters .month-select').dataset['month'] = '';
				document.querySelector('.events-filters .category-select').dataset['category'] = '';

				let n = document.querySelectorAll('.events-filters .calendar-event').length;
				let noProgrammes = document.querySelector('.no-program-error2')
				if (n == 0) {
					noProgrammes.classList.add('d-block')
					noProgrammes.classList.remove('d-none')
				}else{
					noProgrammes.classList.remove('d-block')
					noProgrammes.classList.add('d-none')
				}

				fixMasonry();
				//document.querySelector('.category-select .selected-value').innerHTML = "Category";
			});
		});
		let eventMomthsL = document.querySelectorAll('.events-filters .month-select li');
		let eventCategoryL = document.querySelectorAll('.events-filters .category-select li');

		for (let i=0; i<eventMomthsL.length; i++) {

			eventMomthsL[i].addEventListener('click', function(e) {

				e.preventDefault();
				let month = this.dataset.filter2;
				let events = document.querySelectorAll('.events-filters .calendar-event');

				let category = document.querySelector('.events-filters .category-select').dataset.category;

				let selectedMonthEvents = document.querySelectorAll('.events-filters ' + month+category);
				events.forEach( event => {
					event.classList.add('d-none');
					event.classList.remove('d-block');
				});

				selectedMonthEvents.forEach( selected => {
					selected.classList.remove('d-none');
					selected.classList.add('d-block');
				});

				document.querySelector('.events-filters .month-select .selected-value').innerHTML = this.dataset.month;
				document.querySelector('.events-filters .month-select').dataset.month = month;


				let n = document.querySelectorAll('.events-filters ' + month+category).length;
				let noProgrammes = document.querySelector('.no-program-error2')
				if (n == 0) {
					noProgrammes.classList.add('d-block')
					noProgrammes.classList.remove('d-none')
				}else{
					noProgrammes.classList.remove('d-block')
					noProgrammes.classList.add('d-none')
				}

				fixMasonry();
			})

		}

		for (let i=0; i<eventCategoryL.length; i++) {

			eventCategoryL[i].addEventListener('click', function(e) {
				e.preventDefault();
				let category = this.dataset.filter;
				let events = document.querySelectorAll('.events-filters .calendar-event');
				let month = document.querySelector('.events-filters .month-select').dataset.month;

				let selectedMonthEvents = document.querySelectorAll('.events-filters ' + category+month);
				events.forEach( event => {
					event.classList.add('d-none');
					event.classList.remove('d-block');
				});

				selectedMonthEvents.forEach( selected => {
					selected.classList.remove('d-none');
					selected.classList.add('d-block');
				});

				//document.querySelector('.category-select .selected-value').innerHTML = this.dataset.category;
				document.querySelector('.events-filters .category-select').dataset.category = category;

				let n = document.querySelectorAll('.events-filters ' + category+month).length;
				let noProgrammes = document.querySelector('.no-program-error2')
				if (n == 0) {
					noProgrammes.classList.add('d-block')
					noProgrammes.classList.remove('d-none')
				}else{
					noProgrammes.classList.remove('d-block')
					noProgrammes.classList.add('d-none')
				}
				fixMasonry();
			})

		}

		let cat_select = document.querySelectorAll('.events-filters .category-select li');
		for (let i=0; i<cat_select.length; i++) {
			let selector = document.querySelectorAll('.events-filters #calendar-events-section .calendar-event' + cat_select[i].dataset.filter);
			if (selector.length == 0) {
				cat_select[i].classList.add('d-none');
			}
		}
	}
	const removeActiveTabs = () => {
		document.querySelectorAll('.programme-tabs').forEach(el => {
			el.classList.remove('active-tab');
		})
	}

	const hideTabsContent = () => {
		document.querySelectorAll('.programmes-content').forEach(el => {
			el.classList.add('d-none');
		})
	}

	if ( document.querySelectorAll('.programme-tabs') ) {
		document.querySelectorAll('.programme-tabs').forEach(el => {
			el.addEventListener('click', elem => {
				removeActiveTabs();
				el.classList.add('active-tab');
				hideTabsContent();
				document.querySelector(elem.target.dataset.target).classList.remove('d-none');
			})
		})
	}

});

let parallaxElements = $('*[data-parallax-background-image-url]');

if (parallaxElements.length > 0) {
	parallaxElements.each(function () {
		let parallaxElement = $(this);
		let parallaxImageUrl = parallaxElement.attr('data-parallax-background-image-url');

		if (parallaxImageUrl) {
			parallaxElement.css('background-image', 'url(' + parallaxImageUrl + ')');
		}
	});
}

$(document).ready( function() {

	$(".faqTabs").click(function() {
		$(".tab-panel").removeClass("faqPanelActive");
		$(".label1").removeClass("activeFaqTab");
		$(".faqTabs").removeClass("activeFaqTab")
		$(this).addClass("activeFaqTab");
	});
});

// Function to check if an element is in the viewport
function isInViewport(element) {
	var rect = element.getBoundingClientRect();
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
}

// For homepage work with video on scroll
function handleIntersection(entries, observer) {
	entries.forEach(entry => {
		const autoplayVideos = document.querySelectorAll('.autoplayVideo');
		const miniVideoItemVideos = document.querySelectorAll('.section-mini-video-item video');
		const miniVideoVideos = document.querySelectorAll('.section-mini-video video');

		if (entry.isIntersecting) {
			autoplayVideos.forEach(video => {
				video.play();
				video.classList.add('play-video');
			});

			miniVideoItemVideos.forEach(video => {
				video.play();
				video.classList.add('play-section-mini-video-item');
			});

			miniVideoVideos.forEach(video => {
				video.play();
				video.classList.add('play-section-mini-video');
			});
		} else {
			autoplayVideos.forEach(video => {
				video.pause();
				video.currentTime = 0;
				video.classList.remove('play-video');
			});

			miniVideoItemVideos.forEach(video => {
				video.pause();
				video.currentTime = 0;
				video.classList.remove('play-section-mini-video-item');
			});

			miniVideoVideos.forEach(video => {
				video.pause();
				video.currentTime = 0;
				video.classList.remove('play-section-mini-video');
			});
		}
	});
}

var observer = new IntersectionObserver(handleIntersection);

// Observe all relevant video elements
document.querySelectorAll('.autoplayVideo, .section-mini-video-item video, .section-mini-video video').forEach(video => {
	observer.observe(video);
});


// Function for main popup
function showPopup() {
	const popupElement = document.getElementById("popup");

	if (popupElement) {
		popupElement.classList.remove('d-none');
	}
}

function closePopup() {
	const popupElement = document.getElementById("popup");

	if (popupElement) {
		popupElement.classList.add('d-none');
	}

	const d = new Date();
	d.setTime(d.getTime() + (24 * 60 * 60 * 1000));
	const expires = "expires=" + d.toUTCString();
	document.cookie = "popupClosed=true; " + expires + "; path=/";
}

function checkPopup() {
	const popupClosed = document.cookie.split('; ').find(row => row.startsWith('popupClosed='));
	if (!popupClosed) {
		setTimeout(showPopup, 3500);
	}
}

document.addEventListener("DOMContentLoaded", function () {
	if (document.getElementById("closeButton")) {
		document.getElementById("closeButton").addEventListener("click", closePopup);
	}
	window.addEventListener("load", checkPopup);
});

function setupVideoPlayback() {
	const watch = document.querySelector('.medical-video .inner-video .team-video-buttons .play-bt');
	const watchMainButton = document.querySelector('.medical-video .inner-video .team-video-buttons');
	const videoAutoPlay = document.querySelector('.medical-video .inner-video video');

	if (watch && watchMainButton && videoAutoPlay) {
		watch.addEventListener("click", function () {
			watchMainButton.classList.add("opacity-0");
			videoAutoPlay.setAttribute('autoplay', '');
			videoAutoPlay.setAttribute('controls', '');
			videoAutoPlay.play();
		}, { once: true });
	}
}
function handleResize() {
	setupVideoPlayback();
}
if (document.querySelectorAll('.video-medical').length > 0) {
	window.addEventListener("resize", handleResize);
	handleResize();
}

document.addEventListener("DOMContentLoaded", function () {
	// Start medical page canvas items from dotlottie
	const canvases = document.querySelectorAll("canvas[data-src]");
	const fadeUpElements = document.querySelectorAll('.fade-up');

	const observerCallback = (entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const canvas = entry.target;
				const animationSrc = canvas.getAttribute("data-src");

				import("https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-web/+esm").then(module => {
					const DotLottie = module.DotLottie;
					new DotLottie({
						autoplay: true,
						loop: false,
						canvas: canvas,
						src: animationSrc,
					});
				});

				observer.unobserve(canvas);
			}
		});
	};
	const observerOptions = {
		root: null,
		rootMargin: "0px",
		threshold: 0.1
	};
	const observer = new IntersectionObserver(observerCallback, observerOptions);
	canvases.forEach(canvas => observer.observe(canvas));
	const fadeUpObserverCallback = (entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('show');
				observer.unobserve(entry.target);
			}
		});
	};
	const fadeUpObserver = new IntersectionObserver(fadeUpObserverCallback, observerOptions);
	fadeUpElements.forEach(el => fadeUpObserver.observe(el));
	// end medical page canvas items from dotlottie

	// Start homepage medical section
	function initSlider(container) {
		const items = container.querySelectorAll('.slider-item');
		const images = container.querySelectorAll('.image-mask');
		const titles = container.querySelectorAll('.slider-title');
		let currentIndex = 0;
		const itemsCount = items.length;
		let interval;
		function showItem(index) {
			items.forEach(item => item.classList.remove('active'));
			images.forEach(image => image.classList.remove('active'));
			items[index].classList.add('active');
			images[index].classList.add('active');
		}
		function updateBullets(index) {
			items.forEach((item, idx) => {
				if (idx <= index) {
					item.classList.add('completed');
				} else {
					item.classList.remove('completed');
				}
			});
		}
		function resetBullets() {
			items.forEach(bullet => bullet.classList.remove('completed'));
		}
		function startSlider() {
			interval = setInterval(function() {
				currentIndex = (currentIndex + 1) % itemsCount;
				if (currentIndex === 0) resetBullets();
				showItem(currentIndex);
				updateBullets(currentIndex);
			}, 5000);
		}
		titles.forEach((title, index) => {
			title.addEventListener('click', function() {
				clearInterval(interval);
				currentIndex = index;
				showItem(currentIndex);
				updateBullets(currentIndex);
				startSlider();
			});
		});
		startSlider();
	}
	const whyUs = document.getElementById('homepage-medical-section-choose-us');
	const homeTimeline = document.getElementById('homepage-refactor-timeline');
	if (whyUs) {
		initSlider(whyUs);
	}
	if (homeTimeline) {
		initSlider(homeTimeline);
	}
	// Read more in slider description
	const readMoreButtons = document.querySelectorAll('.read-more-btn');
	readMoreButtons.forEach(button => {
		button.addEventListener('click', function () {
			const description = this.parentElement;
			const shortText = description.querySelector('.short-text');
			const fullText = description.querySelector('.full-text');

			if (fullText.classList.contains('d-none')) {
				shortText.classList.add('d-none');
				description.classList.add('open-read-more');
				fullText.classList.remove('d-none');
				this.textContent = 'Less ';
			} else {
				shortText.classList.remove('d-none');
				fullText.classList.add('d-none');
				description.classList.remove('open-read-more');
				this.textContent = 'More ';
			}
		});
	});
	// End homepage medical section

	// Start begin journey form modal
	const medicalPageModal = document.getElementById('begin-journey');
	if ( medicalPageModal ) {
		const openModal = document.getElementById('open-modal');
		const closeModal = document.getElementById('close-modal');
		const formModal = document.getElementById('form-modal');
		const bodyClick = document.querySelector('page-template-medical');

		openModal.addEventListener('click', function (e) {
			e.preventDefault();
			formModal.classList.remove('d-none');
		});
		closeModal.addEventListener('click', function () {
			formModal.classList.add('d-none');
			bodyClick.classList.add('d-none');
		});
	}
	// End begin journey form modal

	//About page template add ctas
	const formModalCtas = document.getElementById('ctas');
	if ( formModalCtas ) {
		const openModal = document.getElementById('open-modal-ctas');
		const closeModal = document.getElementById('close-modal-ctas');
		const formModal = document.getElementById('form-modal-ctas');
		const bodyClick = document.querySelector('page-template-about-us');

		openModal.addEventListener('click', function (e) {
			e.preventDefault();
			formModal.classList.remove('d-none');
		});
		closeModal.addEventListener('click', function () {
			formModal.classList.add('d-none');
			bodyClick.classList.add('d-none');
		});
	}

});

const initializeAnimationObserver = () => {
	const lineGroups = {
		group1: ['line1', 'line2', 'line3', 'line4', 'line5'], // Longest lines
		group2: ['line6', 'line7', 'line8', 'line9', 'line10'],
		group3: ['line11', 'line12', 'line13', 'line14', 'line15', 'line16', 'line17', 'line18'],
		group4: ['line19', 'line20', 'line21', 'line22', 'line23', 'line24', 'line25', 'line26'],
		group5: ['line27', 'line28', 'line29', 'line30', 'line31', 'line32', 'line33', 'line34'] // Shortest lines
	};

	const baseAnimationDuration = 3; // 3 seconds for group1
	const animationSpeeds = {
		group1: baseAnimationDuration,
		group2: baseAnimationDuration - 0.5,
		group3: baseAnimationDuration - 1,
		group4: baseAnimationDuration - 1.5,
		group5: baseAnimationDuration - 1.5
	};

	const playAnimation = (entries, observerInstance) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const targetId = entry.target.id;
				let targetGroup = null;

				// Determine which group the intersecting line belongs to
				for (const [group, lines] of Object.entries(lineGroups)) {
					if (lines.includes(targetId)) {
						targetGroup = group;
						break;
					}
				}

				if (targetGroup) {
					const duration = animationSpeeds[targetGroup];
					let accumulatedDelay = 0; // Tracks total time to delay the next line

					// Animate all lines in the group
					lineGroups[targetGroup].forEach((lineId) => {
						const line = document.getElementById(lineId);
						if (line && !line.style.animation) {
							// Avoid restarting already animated lines
							line.style.animation = `draw${lineId.replace('line', '')} ${duration}s linear forwards ${accumulatedDelay}s`;
							accumulatedDelay += duration; // Add the duration of this line to the delay for the next
						}
					});
				}
			}
		});
	};

	// Create an IntersectionObserver instance
	const svgObserver = new IntersectionObserver(playAnimation, {
		threshold: 0.1 // The percentage of the element's visibility (10% in this case)
	});

	// Select all lines
	const lines = document.querySelectorAll('#line1, #line2, #line3, #line4, #line5, #line6, #line7, #line8, #line9, #line10, #line11, #line12, #line13, #line14, #line15, #line16, #line17, #line18, #line19, #line20, #line21, #line22, #line23, #line24, #line25, #line26, #line27, #line28, #line29, #line30, #line31, #line32, #line33, #line34');

	// Observe each line
	lines.forEach(line => svgObserver.observe(line));
};

// Initialize the observer
initializeAnimationObserver();

// Reinitialize the observer on screen resize
window.addEventListener('resize', () => {
	initializeAnimationObserver();
});
